import React from 'react'
import PropTypes from 'prop-types'
import { makeButton } from './styled'

export const PureButton = makeButton('button')
export const AnchorButton = makeButton('a')

export function RawButton(props) {
  if (props.href) {
    return <AnchorButton {...props} />
  } else {
    return <PureButton {...props} />
  }
}

function Button(props) {
  return <RawButton {...props} />
}

Button.propTypes = {
  disabled: PropTypes.bool,
  href: PropTypes.string,
  flexible: PropTypes.bool,
  thin: PropTypes.bool,
  secondary: PropTypes.bool,
  emphasis: PropTypes.bool,
  marginTop: PropTypes.string,
  marginBottom: PropTypes.string,
}

Button.defaultProps = {
  disabled: false,
}

export default Button
